import React, { Component } from "react";
import { SERVER_ADDR, gethumorBooks } from "../actions/bookAction";
import { connect } from "react-redux";

import "./homepage.css";
import { Container, Button } from "@material-ui/core";
import { Grid, Image } from "semantic-ui-react";
import Paper from "@material-ui/core/Paper";
import SearchTool from "./searchTool";
import axios from "axios";
var count = 1;
var bookAddress;
export class HumorBooks extends Component {
  constructor() {
    super();
    this.state = { books: [], moredata: {} };
  }
  componentDidMount() {
    this.props.gethumorBooks();
  }
  searchReq = e => {
    count += 1;
    this.fetchMoreResult();
    console.log(count);
  };
  fetchMoreResult = () => {
    var urlLoad = `${SERVER_ADDR}/books?mime_type=image%2Fjpeg&page=${count}&topic=drama`;

    axios
      .get(urlLoad)
      .then(res => {
        this.setState({ moredata: res.data.results });
      })
      .catch(error => {
        if (axios.isCancel(error) || error) {
          this.setState({ loading: false, message: "failed to fetch" });
        }
      });
  };
  renderMoreresult = () => {
    const { moredata } = this.state;
    if (Object.keys(moredata).length && moredata.length) {
      moredata.map((data, index) =>
        data.formats["text/html; charset=utf-8"]
          ? (bookAddress = data.formats["text/html; charset=utf-8"])
          : data.formats["application/pdf"]
          ? (bookAddress = data.formats["application/pdf"])
          : data.formats["text/plain; charset=us-ascii"]
      );
      return (
        <Grid columns={6}>
          <Grid.Row stretched>
            {moredata.map((data, index) => {
              return (
                <React.Fragment key={index}>
                  <Grid.Column only="computer">
                    <Paper>
                      {data.formats["image/jpeg"] ? (
                        <Image
                          src={data.formats["image/jpeg"]}
                          style={{ height: "200px", width: "250px" }}
                        />
                      ) : (
                        "Image NOT Available"
                      )}
                      {
                        <a href={bookAddress}>
                          <h5>{data.title}</h5>
                        </a>
                      }
                    </Paper>
                    <br />
                    <br />
                    <br />
                    <br />
                  </Grid.Column>
                </React.Fragment>
              );
            })}
          </Grid.Row>
        </Grid>
      );
    }
  };
  render() {
    const { books } = this.props.books;
    var bookList;

    if (books) {
      if (books.results) {
        if (books.results) {
          books.results.map((data, index) =>
            data.formats["text/html; charset=utf-8"]
              ? (bookAddress = data.formats["text/html; charset=utf-8"])
              : ""
          );
        }
        bookList = (
          <Grid columns={6}>
            <Grid.Row stretched>
              {books.results.map((data, index) => (
                <React.Fragment key={index}>
                  <Grid.Column only="computer">
                    <Paper>
                      {data.formats["image/jpeg"] ? (
                        <Image
                          src={data.formats["image/jpeg"]}
                          style={{ height: "200px", width: "250px" }}
                        />
                      ) : (
                        "NO"
                      )}
                      {
                        <a href={bookAddress}>
                          <h5>{data.title}</h5>
                        </a>
                      }
                    </Paper>
                    <br />
                    <br />
                    <br />
                    <br />
                  </Grid.Column>

                  <Grid.Column only="mobile" mobile={5}>
                    <Paper>
                      {data.formats["image/jpeg"] ? (
                        <Image
                          src={data.formats["image/jpeg"]}
                          style={{ height: "100px", width: "100px" }}
                        />
                      ) : (
                        "NO"
                      )}
                      {
                        <a href={bookAddress}>
                          <h5>{data.title}</h5>
                        </a>
                      }
                    </Paper>
                    <br />
                    <br />
                    <br />
                  </Grid.Column>
                </React.Fragment>
              ))}
              ;
            </Grid.Row>
          </Grid>
        );
      }
    }

    return (
      <Container>
        <SearchTool />
        <h1>Humor</h1>
        {bookList}
        {this.renderMoreresult()}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          style={{ marginLeft: "9px" }}
          onClick={this.searchReq}
        >
          Load More
        </Button>
        <br />
        <br />
        <br />
        <br />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  books: state.books
});

export default connect(
  mapStateToProps,
  { gethumorBooks }
)(HumorBooks);
